import { Block } from './block';

const Blocks = ({ data = [], blockLevel = 0, ...rest }) =>
  data.map((block) => (
    <Block key={block.key} block={block} blockLevel={blockLevel} {...rest} />
  ));

export { Blocks };
